/**
 * Handler to reload the Symfony Debug Toolbar after navigating to a frame.
 */
export default class MissingFrameHandler {
    constructor() {
        document.addEventListener('turbo:frame-render', this._reloadDebugBar);
    }

    _reloadDebugBar(event) {
        if (typeof Sfjs === 'undefined' || typeof Sfjs.loadToolbar === 'undefined') {
            return;
        }

        const newToken = event.detail.fetchResponse.response.headers.get('x-debug-token');
        if (!newToken) {
            return;
        }

        const toolbar = document.querySelector('[id^="sfwdt"]');
        if (!toolbar) {
            return;
        }

        const oldToken = toolbar.id.replace(/^sfwdt/, '');
        if (!oldToken) {
            return;
        }

        Sfjs.loadToolbar(oldToken, newToken);
    }
}
